import { lazy, Suspense } from 'react';
import type { PdfViewerProps } from './PdfViewer';

const PdfViewer = lazy(() => import('./PdfViewer'));

export function DocumentViewerSkeleton() {
  return (
    <div className="flex h-full items-center justify-center bg-muted/35 text-sm text-muted-foreground">
      Chargement de l’aperçu...
    </div>
  );
}

export function PdfViewerLazy(props: PdfViewerProps) {
  return (
    <Suspense fallback={<DocumentViewerSkeleton />}>
      <PdfViewer {...props} />
    </Suspense>
  );
}
